let mockEmployees = [
  {
    id: 1,
    code: '12457890004',
    firstName: 'Sudheesh Kumar',
    lastName: 'Name1',
    position: 'Sr Software Developer',
    department: 'Product Revamp',
    shiftName: 'Morning to evening',
    startDate: '02-09-2025',
    endDate: '03-09-2025',
  },
  {
    id: 2,
    code: '12457890005',
    firstName: 'Chirag',
    lastName: 'Korat',
    position: 'Frontend Developer',
    department: 'Product Revamp',
    shiftName: 'Day Shift',
    startDate: '03-09-2025',
    endDate: '04-09-2025',
  },

  {
    id: 3,
    code: '12457890006',
    firstName: 'Hazem',
    lastName: 'Naim',
    position: 'Sr. Frontend Developer',
    department: 'Product Revamp',
    shiftName: 'Night Shift',
    startDate: '04-09-2025',
    endDate: '05-09-2025',
  },

  {
    id: 4,
    code: '12457890007',
    firstName: 'Hiren',
    lastName: 'Patel',
    position: 'Sr UI & UX Developer',
    department: 'Product Revamp',
    shiftName: 'Evening Shift',
    startDate: '05-09-2025',
    endDate: '06-09-2025',
  },

  {
    id: 5,
    code: '12457890008',
    firstName: 'Kamlesh',
    lastName: 'Patel',
    position: 'DevOps Engineer',
    department: 'Product Revamp',
    shiftName: 'Rotating Shift',
    startDate: '06-09-2025',
    endDate: '07-09-2025',
  },
];
let empIdCounter = mockEmployees.length + 1;

const EmployeeAPI = {
  getAll: async () =>
    new Promise((resolve) => {
      setTimeout(() => resolve({ data: { data: [...mockEmployees] } }), 300);
    }),

  add: async (newData) =>
    new Promise((resolve) => {
      setTimeout(() => {
        const newItem = { ...newData, id: empIdCounter++ };
        mockEmployees = [...mockEmployees, newItem];
        resolve({ data: { data: newItem } });
      }, 300);
    }),

  update: async (id, updatedData) =>
    new Promise((resolve) => {
      setTimeout(() => {
        const idx = mockEmployees.findIndex((e) => e.id === id);
        if (idx !== -1)
          mockEmployees[idx] = { ...mockEmployees[idx], ...updatedData };
        resolve({ data: { data: mockEmployees[idx] } });
      }, 300);
    }),

  delete: async (ids) =>
    new Promise((resolve) => {
      setTimeout(() => {
        const idsArr = Array.isArray(ids) ? ids : [ids];
        mockEmployees = mockEmployees.filter((e) => !idsArr.includes(e.id));
        resolve({ status: 200, data: { deletedIds: idsArr } });
      }, 300);
    }),
};

export default EmployeeAPI;
